// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* New OrderDashboard Layout - Essential positioning styles kept */

.new-dashboard-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  min-height: 0;
  width: 100%;
}

/* Top Header Section - Fixed */
.dashboard-top-header {
  background: white;
  padding: 8px 16px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 0;
  z-index: 100;
  margin-right: 380px;
  min-height: 90px;
  gap: 16px;
}

/* Header Left Section - Order Types and Action Buttons */
.header-left-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-shrink: 0;
}

.header-order-types {
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.header-order-types .btn {
  padding: 5px 16px;
  font-weight: 600;
  font-size: 13px;
  white-space: nowrap;
  min-width: 110px;
  text-align: center;
  border-radius: 0;
  border-right-width: 0;
}

.header-order-types .btn:first-child {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

.header-order-types .btn:last-child {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  border-right-width: 1px;
}

.header-order-types .btn-primary {
  z-index: 1;
  border-right-width: 1px;
}

.header-action-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.header-action-buttons .wifi-on-btn {
  background-color: #28a745;
  /* height: 32px;
  width: 32px;/ */
  /* padding: 0; */
}

.header-action-buttons .wifi-off-btn {
  background-color: #dc3545;
  /* height: 32px;
  width: 32px;
  padding: 0; */
}

/* Header Right - Tables Grid */
.header-right-tables {
  flex: 1;
  overflow: hidden;
  max-height: 74px;
  display: flex;
  position: relative;
  overflow: visible;
  /* align-items: center; */
}


.header-timer {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #495057;
  font-weight: 500;
  padding: 8px 8px;
  background: #F1F1F1;
  border-radius: 6px;
  white-space: nowrap;
}

.booking-btn {
  background: #FAC800;
  color: white;
  border:none;
}

.header-timer i {
  font-size: 16px;
  color: #6c757d;
}

.header-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 6px;
  font-weight: 500;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
}

.header-btn i {
  font-size: 16px;
}

.table-buttons-wrapper {
  position: absolute;
  top: -40px;
  left: 0;
  right: 0;
  max-height: 80px;
  gap: 0.3rem;
  overflow-y: hidden;
  background: white;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  border-radius: 6px;
  transition: max-height 0.3s ease;
  z-index: 200;
  padding: 0.4rem;
}

.header-right-tables:hover .table-buttons-wrapper {
  max-height: 300px;
  overflow-y: auto;
}

.table-button {
  width: 40px;
  height: 32px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 12px;
  padding: 0;
  line-height: 1;
}

.table-button.btn:focus {
  background-color: #212529 !important;
  color: white !important;
}

/* Table Button Wrapper for Delete Icon */
.table-button-wrapper {
  position: relative;
  display: inline-block;
}

.table-button-wrapper:hover .table-delete-btn {
  opacity: 1;
  visibility: visible;
}

/* Delete Icon on Table Buttons */
.table-delete-btn {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: white;
  border: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

.table-delete-btn:hover {
  transform: scale(1.15);
}

.table-delete-btn .mdi-close-circle {
  font-size: 18px;
  color: #dc3545;
}

.table-delete-btn:active {
  transform: scale(0.9);
}

.table-buttons-wrapper::-webkit-scrollbar {
  width: 6px;
}

.table-buttons-wrapper::-webkit-scrollbar-track {
  background: #f8f9fa;
}

.table-buttons-wrapper::-webkit-scrollbar-thumb {
  background: #dee2e6;
  border-radius: 3px;
}

.table-buttons-wrapper::-webkit-scrollbar-thumb:hover {
  background: #adb5bd;
}

/* Main Content Section */
.dashboard-main-content {
  display: flex;
  flex: 1;
  overflow: hidden;
  margin-right: 380px;
  min-height: 0;
}

/* Left Side - Items Section */
.dashboard-left-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  min-height: 0;
}

.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
  font-size: 16px;
  pointer-events: none;
}

/* Items Grid Section */
.items-grid-section {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  flex-wrap: wrap;
}

.item-image-placeholder {
  width: 100%;
  height: 120px;
  background: #f8f9fa;
  border-radius: 0.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #adb5bd;
  font-size: 14px;
  overflow: hidden;
}

.cursor-pointer {
  cursor: pointer;
  transition: transform 0.2s ease;
}

/* Right Side - Order Summary - Fixed Position */
.dashboard-right-sidebar {
  width: 380px;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex-shrink: 0;
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 98;
}

.dashboard-right-sidebar .current-order-info div {
  border-radius: 6px;
  overflow: hidden;
  white-space: nowrap;
  max-width: 200px;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: middle;
  line-height: 1.2;
  font-size: 14px;
}

/* Purple background for KOT headers */
.bg-purple {
  background-color: #9ba7ca !important;
}

/* Gap utility (for flex containers in Bootstrap 4) */
.gap-1 {
  gap: 0.25rem;
}

.gap-2 {
  gap: 0.5rem;
}

.search-category-section input{
  height: 40px;
  font-size: 14px;
  padding-left: 35px;
}

/* Category Dropdown Selector - Compact */
.category-dropdown-wrapper {
  position: relative;
}

.category-dropdown-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 10px;
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  height: 40px;
}

.category-dropdown-toggle:hover {
  border-color: #007bff;
  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.1);
}

.category-dropdown-image {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  overflow: hidden;
  margin-right: 8px;
  flex-shrink: 0;
  position: relative;
}

.category-dropdown-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.category-dropdown-icon {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  border-radius: 4px;
}

.category-dropdown-text {
  font-size: 13px;
  font-weight: 500;
  color: #495057;
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.category-dropdown-arrow {
  font-size: 18px;
  color: #6c757d;
  transition: transform 0.2s ease;
  margin-left: 6px;
  flex-shrink: 0;
}

.category-dropdown-arrow.open {
  transform: rotate(180deg);
}

/* Dropdown Menu */
.category-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 4px;
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-height: 280px;
  overflow-y: auto;
  z-index: 1000;
  animation: dropdownSlideIn 0.2s ease;
}

@keyframes dropdownSlideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.category-dropdown-item {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  cursor: pointer;
  transition: background-color 0.15s ease;
  border-bottom: 1px solid #f8f9fa;
}

.category-dropdown-item:last-child {
  border-bottom: none;
}

.category-dropdown-item:hover {
  background-color: #f8f9fa;
}

.category-dropdown-item.active {
  background-color: #e7f3ff;
}

.category-dropdown-item .category-dropdown-text {
  font-size: 13px;
}

.category-dropdown-item .category-dropdown-image {
  width: 28px;
  height: 28px;
  margin-right: 10px;
}

/* Scrollbar for dropdown */
.category-dropdown-menu::-webkit-scrollbar {
  width: 6px;
}

.category-dropdown-menu::-webkit-scrollbar-track {
  background: #f8f9fa;
}

.category-dropdown-menu::-webkit-scrollbar-thumb {
  background: #dee2e6;
  border-radius: 3px;
}

.category-dropdown-menu::-webkit-scrollbar-thumb:hover {
  background: #adb5bd;
}

/* General Custom Select Component */
.custom-select-wrapper {
  position: relative;
  min-width: 150px;
}

.custom-select-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px;
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  height: 36px;
  white-space: nowrap;
}

.custom-select-toggle:hover {
  border-color: #007bff;
  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.1);
}

.custom-select-text {
  font-size: 13px;
  font-weight: 500;
  color: #495057;
  overflow: hidden;
  text-overflow: ellipsis;
}

.custom-select-arrow {
  font-size: 18px;
  color: #6c757d;
  transition: transform 0.2s ease;
  margin-left: 6px;
  flex-shrink: 0;
}

.custom-select-arrow.open {
  transform: rotate(180deg);
}

/* Custom Select Dropdown Menu */
.custom-select-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 4px;
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-height: 250px;
  overflow-y: auto;
  z-index: 1000;
  animation: dropdownSlideIn 0.2s ease;
  min-width: 180px;
}

.custom-select-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  transition: background-color 0.15s ease;
  border-bottom: 1px solid #f8f9fa;
}

.custom-select-item:last-child {
  border-bottom: none;
}

.custom-select-item:hover {
  background-color: #f8f9fa;
}

.custom-select-item.active {
  background-color: #e7f3ff;
}

/* Scrollbar for custom select */
.custom-select-menu::-webkit-scrollbar {
  width: 6px;
}

.custom-select-menu::-webkit-scrollbar-track {
  background: #f8f9fa;
}

.custom-select-menu::-webkit-scrollbar-thumb {
  background: #dee2e6;
  border-radius: 3px;
}

.custom-select-menu::-webkit-scrollbar-thumb:hover {
  background: #adb5bd;
}

/* Table Type Selector Specific */
.table-type-selector {
  min-width: 130px;
}

/* Scrollbar Styling */
.items-grid-section::-webkit-scrollbar,
.overflow-auto::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.items-grid-section::-webkit-scrollbar-track,
.overflow-auto::-webkit-scrollbar-track {
  background: #f8f9fa;
}

.items-grid-section::-webkit-scrollbar-thumb,
.overflow-auto::-webkit-scrollbar-thumb {
  background: #dee2e6;
  border-radius: 3px;
}

.items-grid-section::-webkit-scrollbar-thumb:hover,
.overflow-auto::-webkit-scrollbar-thumb:hover {
  background: #adb5bd;
}

.no-spinner::-webkit-outer-spin-button,
.no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}

.no-spinner[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-customer .modal-content {
  background: white;
  border-radius: 8px;
  max-width: 400px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.modal-header {
  padding: 16px 20px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.modal-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.modal-close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #6c757d;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.modal-close-btn:hover {
  background: #f8f9fa;
  color: #212529;
}

.modal-body {
  padding: 20px;
  overflow-y: auto;
  flex: 1;
}

.section-title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 2px solid #e9ecef;
}

.modal-footer {
  padding: 16px 20px;
  border-top: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

.modal-footer .btn {
  min-width: 100px;
}

.action-buttons{
  column-gap: 0.5rem;
}

.action-buttons .row{
  row-gap: 0.2rem;
  column-gap: 0.5rem;
  flex-basis: 70%;
}

.action-buttons .settle{
  flex-basis: 30%;
}

.action-buttons .settle .btn {
  background: #28a745;
}

.action-buttons .settle .title {
  font-size: 14px;
}

.action-buttons .settle .total {
  font-size: 16px;
  line-height: 14px;
}

/* Customer Details Accordion Styles */
.cursor-pointer {
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.item-card{
  border-radius: 0.7rem;
  background-color: none;
}

.item-card:hover{
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.15) !important;
}

.item-card .item-img {
  border-radius: 0.7rem;
}

.cursor-pointer .card-title{
  font-size: 14px;
}

.font-weight-medium {
  font-weight: 500;
}

/* Remove spinner from number inputs in accordion */
.no-spinner::-webkit-outer-spin-button,
.no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.no-spinner {
  -moz-appearance: textfield;
  appearance: textfield;
}

/* Disabled quantity button styles */
.btn-outline-dark:disabled,
.btn-outline-dark.disabled {
  opacity: 0.4;
  cursor: not-allowed;
  pointer-events: none;
}

/* Mobile Cart View Accordion Styles */
@media (max-width: 768px) {
  /* Make accordion header more mobile-friendly */
  .border-top .p-3 {
    padding: 0.75rem !important;
    background-color: #f8f9fa;
    border-radius: 6px;
    margin-bottom: 0.5rem;
  }

  /* Mobile accordion content styling */
  .border-top .px-3 {
    padding-left: 0.75rem !important;
    padding-right: 0.75rem !important;
  }

  /* Mobile form controls in accordion */
  .border-top .form-control-sm {
    font-size: 14px;
    padding: 0.5rem;
  }

  /* Mobile autocomplete dropdown */
  .border-top .position-absolute.bg-white {
    max-height: 150px !important;
    font-size: 13px;
  }

  /* Mobile accordion animation */
  .border-top .collapse {
    transition: height 0.3s ease;
  }
}



/* Dropdown Menu */
.dropdown-menu-custom {
  background: #ffffff;
  border-top: 1px solid #e5e7eb;
  border-bottom: 1px solid #e5e7eb;
  animation: slideDown 0.2s ease-out;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 50;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Order Summary Header - Clean Design */
.order-summary-header-wrapper {
  position: relative;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  border-bottom: 1px solid #e9ecef;

}

.header-left {
  flex: 1;
}

.header-title {
  font-size: 18px;
  font-weight: 700;
  color: #2c3e50;
}

.header-title span {
  font-size: 12px;
  font-weight: 500;
  color: #272829;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

/* Table/Order Badge - Less Rounded, More Rectangular */
.info-badge {
  background: #303e67;
  color: white;
  padding: 2px 4px;
  border-radius: 4px; /* Changed from 12px to 4px for rectangular look */
  font-size: 10px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.info-number {
  background: #f8f9fa;
  color: #495057;
  padding: 4px 10px;
  border-radius: 4px; /* More rectangular */
  font-size: 11px;
  font-weight: 600;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.person-info {
  font-size: 12px;
  color: #6c757d;
  display: flex;
  align-items: center;
  gap: 4px;
  background: #f1f1f1;
  padding: 4px 10px;
  border-radius: 4px;
}

.person-info span {
  max-width: 100px;
  overflow: hidden;
  position: relative;
  display: inline-block;
  margin: 0 5px 0 5px;
  text-align: center;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Hide the dropdown trigger - Only show dropdown on hover */
.dropdown-trigger {
  display: none; /* Remove the visible selector/trigger */
}

/* Tabs Section */
.dropdown-tabs-custom {
  display: flex;
  gap: 4px;
  padding: 8px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  flex-shrink: 0;
}

.tab-custom {
  flex: 1;
  padding: 8px 12px;
  border: none;
  background: white;
  border-radius: 4px; /* Less rounded */
  font-size: 12px;
  font-weight: 600;
  color: #6c757d;
  cursor: pointer;
  transition: all 0.2s ease;
}

.tab-custom:hover {
  background: #e9ecef;
  color: #495057;
}

.tab-custom.active {
  background: #212529;
  color: white;
}

.tab-custom-label {
  white-space: nowrap;
}

/* Orders List in Dropdown */
.orders-list-dropdown {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
  max-height: calc(65vh - 60px);
}

.order-card-dropdown {
  padding: 12px;
  margin-bottom: 8px;
  border-radius: 6px; /* Less rounded - more rectangular */
  cursor: pointer;
  transition: all 0.2s ease;
  /* border: 2px solid transparent; */
  position: relative;
}

.order-card-dropdown.active {
  box-shadow: 0 2px 12px rgba(102, 126, 234, 0.3);
}

.order-card-dropdown:last-child {
  margin-bottom: 0;
}

.order-card-header {
  font-size: 13px;
}

.order-card-dropdown .fw-bold {
  font-size: 14px;
  color: #2c3e50;
}

.order-card-dropdown.active{
  border: 2px solid #212529;
}

.order-card-dropdown .badge-sm {
  font-size: 10px;
  padding: 3px 8px;
  border-radius: 3px; /* Less rounded for badges */
}

/* Delete Button Styling in Order Cards */
.order-delete-btn {
  background: transparent;
  border: none;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 10;
  position: relative;
}

.order-delete-btn:hover {
  transform: scale(1.2);
}

.order-delete-btn:active {
  transform: scale(0.95);
}

.order-delete-btn .mdi-close-circle {
  font-size: 20px;
}

/* Scrollbar styling for dropdown */
.dropdown-menu-custom::-webkit-scrollbar,
.orders-list-dropdown::-webkit-scrollbar {
  width: 6px;
}

.dropdown-menu-custom::-webkit-scrollbar-track,
.orders-list-dropdown::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.dropdown-menu-custom::-webkit-scrollbar-thumb,
.orders-list-dropdown::-webkit-scrollbar-thumb {
  background: #cbd5e0;
  border-radius: 10px;
}

.dropdown-menu-custom::-webkit-scrollbar-thumb:hover,
.orders-list-dropdown::-webkit-scrollbar-thumb:hover {
  background: #a0aec0;
}

/* Empty state */
.orders-list-dropdown .text-muted {
  user-select: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/OrderDashboard/NewOrderDashboard.css"],"names":[],"mappings":"AAAA,kEAAkE;;AAElE;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB;iBACe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB;;eAEa;AACf;;AAEA,+BAA+B;AAC/B;EACE,OAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,sCAAsC;EACtC,kBAAkB;EAClB,gCAAgC;EAChC,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,OAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA,8BAA8B;AAC9B;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,yCAAyC;EACzC,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA,uBAAuB;AACvB;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA,gDAAgD;AAChD;EACE,YAAY;EACZ,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,QAAQ;EACR,MAAM;EACN,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,oCAAoC;AACtC;;AAEA,qDAAqD;AACrD;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;;EAEE,UAAU;EACV,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,wBAAwB;EACxB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA,oCAAoC;AACpC;;EAEE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,sCAAsC;AACtC;EACE,+CAA+C;EAC/C;IACE,2BAA2B;IAC3B,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA,qCAAqC;EACrC;IACE,gCAAgC;IAChC,iCAAiC;EACnC;;EAEA,sCAAsC;EACtC;IACE,eAAe;IACf,eAAe;EACjB;;EAEA,iCAAiC;EACjC;IACE,4BAA4B;IAC5B,eAAe;EACjB;;EAEA,+BAA+B;EAC/B;IACE,4BAA4B;EAC9B;AACF;;;;AAIA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;EAChC,kCAAkC;EAClC,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;AACb;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gCAAgC;;AAElC;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA,uDAAuD;AACvD;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB,EAAE,kDAAkD;EACtE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB,EAAE,qBAAqB;EACzC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,4DAA4D;AAC5D;EACE,aAAa,EAAE,wCAAwC;AACzD;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB,EAAE,iBAAiB;EACrC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,OAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB,EAAE,oCAAoC;EACxD,eAAe;EACf,yBAAyB;EACzB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB,EAAE,4BAA4B;AAClD;;AAEA,yCAAyC;AACzC;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA,mCAAmC;AACnC;;EAEE,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;AACnB","sourcesContent":["/* New OrderDashboard Layout - Essential positioning styles kept */\n\n.new-dashboard-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n  min-height: 0;\n  width: 100%;\n}\n\n/* Top Header Section - Fixed */\n.dashboard-top-header {\n  background: white;\n  padding: 8px 16px;\n  border-bottom: 1px solid #e9ecef;\n  display: flex;\n  align-items: center;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  margin-right: 380px;\n  min-height: 90px;\n  gap: 16px;\n}\n\n/* Header Left Section - Order Types and Action Buttons */\n.header-left-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.header-order-types {\n  border-radius: 6px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.header-order-types .btn {\n  padding: 5px 16px;\n  font-weight: 600;\n  font-size: 13px;\n  white-space: nowrap;\n  min-width: 110px;\n  text-align: center;\n  border-radius: 0;\n  border-right-width: 0;\n}\n\n.header-order-types .btn:first-child {\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n\n.header-order-types .btn:last-child {\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n  border-right-width: 1px;\n}\n\n.header-order-types .btn-primary {\n  z-index: 1;\n  border-right-width: 1px;\n}\n\n.header-action-buttons {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.header-action-buttons .wifi-on-btn {\n  background-color: #28a745;\n  /* height: 32px;\n  width: 32px;/ */\n  /* padding: 0; */\n}\n\n.header-action-buttons .wifi-off-btn {\n  background-color: #dc3545;\n  /* height: 32px;\n  width: 32px;\n  padding: 0; */\n}\n\n/* Header Right - Tables Grid */\n.header-right-tables {\n  flex: 1;\n  overflow: hidden;\n  max-height: 74px;\n  display: flex;\n  position: relative;\n  overflow: visible;\n  /* align-items: center; */\n}\n\n\n.header-timer {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  color: #495057;\n  font-weight: 500;\n  padding: 8px 8px;\n  background: #F1F1F1;\n  border-radius: 6px;\n  white-space: nowrap;\n}\n\n.booking-btn {\n  background: #FAC800;\n  color: white;\n  border:none;\n}\n\n.header-timer i {\n  font-size: 16px;\n  color: #6c757d;\n}\n\n.header-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-weight: 500;\n  font-size: 13px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.header-btn i {\n  font-size: 16px;\n}\n\n.table-buttons-wrapper {\n  position: absolute;\n  top: -40px;\n  left: 0;\n  right: 0;\n  max-height: 80px;\n  gap: 0.3rem;\n  overflow-y: hidden;\n  background: white;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  border-radius: 6px;\n  transition: max-height 0.3s ease;\n  z-index: 200;\n  padding: 0.4rem;\n}\n\n.header-right-tables:hover .table-buttons-wrapper {\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.table-button {\n  width: 40px;\n  height: 32px;\n  border-radius: 4px;\n  font-weight: 600;\n  font-size: 12px;\n  padding: 0;\n  line-height: 1;\n}\n\n.table-button.btn:focus {\n  background-color: #212529 !important;\n  color: white !important;\n}\n\n/* Table Button Wrapper for Delete Icon */\n.table-button-wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n.table-button-wrapper:hover .table-delete-btn {\n  opacity: 1;\n  visibility: visible;\n}\n\n/* Delete Icon on Table Buttons */\n.table-delete-btn {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: white;\n  border: none;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 10;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n}\n\n.table-delete-btn:hover {\n  transform: scale(1.15);\n}\n\n.table-delete-btn .mdi-close-circle {\n  font-size: 18px;\n  color: #dc3545;\n}\n\n.table-delete-btn:active {\n  transform: scale(0.9);\n}\n\n.table-buttons-wrapper::-webkit-scrollbar {\n  width: 6px;\n}\n\n.table-buttons-wrapper::-webkit-scrollbar-track {\n  background: #f8f9fa;\n}\n\n.table-buttons-wrapper::-webkit-scrollbar-thumb {\n  background: #dee2e6;\n  border-radius: 3px;\n}\n\n.table-buttons-wrapper::-webkit-scrollbar-thumb:hover {\n  background: #adb5bd;\n}\n\n/* Main Content Section */\n.dashboard-main-content {\n  display: flex;\n  flex: 1;\n  overflow: hidden;\n  margin-right: 380px;\n  min-height: 0;\n}\n\n/* Left Side - Items Section */\n.dashboard-left-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background: white;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  overflow: hidden;\n  min-height: 0;\n}\n\n.search-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #6c757d;\n  font-size: 16px;\n  pointer-events: none;\n}\n\n/* Items Grid Section */\n.items-grid-section {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  min-height: 0;\n  flex-wrap: wrap;\n}\n\n.item-image-placeholder {\n  width: 100%;\n  height: 120px;\n  background: #f8f9fa;\n  border-radius: 0.7rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #adb5bd;\n  font-size: 14px;\n  overflow: hidden;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n  transition: transform 0.2s ease;\n}\n\n/* Right Side - Order Summary - Fixed Position */\n.dashboard-right-sidebar {\n  width: 380px;\n  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.08);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  flex-shrink: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 98;\n}\n\n.dashboard-right-sidebar .current-order-info div {\n  border-radius: 6px;\n  overflow: hidden;\n  white-space: nowrap;\n  max-width: 200px;\n  text-overflow: ellipsis;\n  display: inline-block;\n  vertical-align: middle;\n  line-height: 1.2;\n  font-size: 14px;\n}\n\n/* Purple background for KOT headers */\n.bg-purple {\n  background-color: #9ba7ca !important;\n}\n\n/* Gap utility (for flex containers in Bootstrap 4) */\n.gap-1 {\n  gap: 0.25rem;\n}\n\n.gap-2 {\n  gap: 0.5rem;\n}\n\n.search-category-section input{\n  height: 40px;\n  font-size: 14px;\n  padding-left: 35px;\n}\n\n/* Category Dropdown Selector - Compact */\n.category-dropdown-wrapper {\n  position: relative;\n}\n\n.category-dropdown-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 10px;\n  background: white;\n  border: 1px solid #e9ecef;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  height: 40px;\n}\n\n.category-dropdown-toggle:hover {\n  border-color: #007bff;\n  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.1);\n}\n\n.category-dropdown-image {\n  width: 24px;\n  height: 24px;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-right: 8px;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.category-dropdown-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.category-dropdown-icon {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  border-radius: 4px;\n}\n\n.category-dropdown-text {\n  font-size: 13px;\n  font-weight: 500;\n  color: #495057;\n  flex-grow: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.category-dropdown-arrow {\n  font-size: 18px;\n  color: #6c757d;\n  transition: transform 0.2s ease;\n  margin-left: 6px;\n  flex-shrink: 0;\n}\n\n.category-dropdown-arrow.open {\n  transform: rotate(180deg);\n}\n\n/* Dropdown Menu */\n.category-dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  margin-top: 4px;\n  background: white;\n  border: 1px solid #e9ecef;\n  border-radius: 6px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  max-height: 280px;\n  overflow-y: auto;\n  z-index: 1000;\n  animation: dropdownSlideIn 0.2s ease;\n}\n\n@keyframes dropdownSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.category-dropdown-item {\n  display: flex;\n  align-items: center;\n  padding: 8px 10px;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n  border-bottom: 1px solid #f8f9fa;\n}\n\n.category-dropdown-item:last-child {\n  border-bottom: none;\n}\n\n.category-dropdown-item:hover {\n  background-color: #f8f9fa;\n}\n\n.category-dropdown-item.active {\n  background-color: #e7f3ff;\n}\n\n.category-dropdown-item .category-dropdown-text {\n  font-size: 13px;\n}\n\n.category-dropdown-item .category-dropdown-image {\n  width: 28px;\n  height: 28px;\n  margin-right: 10px;\n}\n\n/* Scrollbar for dropdown */\n.category-dropdown-menu::-webkit-scrollbar {\n  width: 6px;\n}\n\n.category-dropdown-menu::-webkit-scrollbar-track {\n  background: #f8f9fa;\n}\n\n.category-dropdown-menu::-webkit-scrollbar-thumb {\n  background: #dee2e6;\n  border-radius: 3px;\n}\n\n.category-dropdown-menu::-webkit-scrollbar-thumb:hover {\n  background: #adb5bd;\n}\n\n/* General Custom Select Component */\n.custom-select-wrapper {\n  position: relative;\n  min-width: 150px;\n}\n\n.custom-select-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 10px;\n  background: white;\n  border: 1px solid #e9ecef;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  height: 36px;\n  white-space: nowrap;\n}\n\n.custom-select-toggle:hover {\n  border-color: #007bff;\n  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.1);\n}\n\n.custom-select-text {\n  font-size: 13px;\n  font-weight: 500;\n  color: #495057;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.custom-select-arrow {\n  font-size: 18px;\n  color: #6c757d;\n  transition: transform 0.2s ease;\n  margin-left: 6px;\n  flex-shrink: 0;\n}\n\n.custom-select-arrow.open {\n  transform: rotate(180deg);\n}\n\n/* Custom Select Dropdown Menu */\n.custom-select-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  margin-top: 4px;\n  background: white;\n  border: 1px solid #e9ecef;\n  border-radius: 6px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  max-height: 250px;\n  overflow-y: auto;\n  z-index: 1000;\n  animation: dropdownSlideIn 0.2s ease;\n  min-width: 180px;\n}\n\n.custom-select-item {\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n  border-bottom: 1px solid #f8f9fa;\n}\n\n.custom-select-item:last-child {\n  border-bottom: none;\n}\n\n.custom-select-item:hover {\n  background-color: #f8f9fa;\n}\n\n.custom-select-item.active {\n  background-color: #e7f3ff;\n}\n\n/* Scrollbar for custom select */\n.custom-select-menu::-webkit-scrollbar {\n  width: 6px;\n}\n\n.custom-select-menu::-webkit-scrollbar-track {\n  background: #f8f9fa;\n}\n\n.custom-select-menu::-webkit-scrollbar-thumb {\n  background: #dee2e6;\n  border-radius: 3px;\n}\n\n.custom-select-menu::-webkit-scrollbar-thumb:hover {\n  background: #adb5bd;\n}\n\n/* Table Type Selector Specific */\n.table-type-selector {\n  min-width: 130px;\n}\n\n/* Scrollbar Styling */\n.items-grid-section::-webkit-scrollbar,\n.overflow-auto::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n.items-grid-section::-webkit-scrollbar-track,\n.overflow-auto::-webkit-scrollbar-track {\n  background: #f8f9fa;\n}\n\n.items-grid-section::-webkit-scrollbar-thumb,\n.overflow-auto::-webkit-scrollbar-thumb {\n  background: #dee2e6;\n  border-radius: 3px;\n}\n\n.items-grid-section::-webkit-scrollbar-thumb:hover,\n.overflow-auto::-webkit-scrollbar-thumb:hover {\n  background: #adb5bd;\n}\n\n.no-spinner::-webkit-outer-spin-button,\n.no-spinner::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  appearance: none;\n  margin: 0;\n}\n\n.no-spinner[type=\"number\"] {\n  -moz-appearance: textfield;\n  appearance: textfield;\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.modal-customer .modal-content {\n  background: white;\n  border-radius: 8px;\n  max-width: 400px;\n  max-height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n}\n\n.modal-header {\n  padding: 16px 20px;\n  border-bottom: 1px solid #e9ecef;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.modal-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.modal-close-btn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: #6c757d;\n  cursor: pointer;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.modal-close-btn:hover {\n  background: #f8f9fa;\n  color: #212529;\n}\n\n.modal-body {\n  padding: 20px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.section-title {\n  font-size: 15px;\n  font-weight: 600;\n  margin-bottom: 12px;\n  padding-bottom: 8px;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.modal-footer {\n  padding: 16px 20px;\n  border-top: 1px solid #e9ecef;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.modal-footer .btn {\n  min-width: 100px;\n}\n\n.action-buttons{\n  column-gap: 0.5rem;\n}\n\n.action-buttons .row{\n  row-gap: 0.2rem;\n  column-gap: 0.5rem;\n  flex-basis: 70%;\n}\n\n.action-buttons .settle{\n  flex-basis: 30%;\n}\n\n.action-buttons .settle .btn {\n  background: #28a745;\n}\n\n.action-buttons .settle .title {\n  font-size: 14px;\n}\n\n.action-buttons .settle .total {\n  font-size: 16px;\n  line-height: 14px;\n}\n\n/* Customer Details Accordion Styles */\n.cursor-pointer {\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.item-card{\n  border-radius: 0.7rem;\n  background-color: none;\n}\n\n.item-card:hover{\n  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.15) !important;\n}\n\n.item-card .item-img {\n  border-radius: 0.7rem;\n}\n\n.cursor-pointer .card-title{\n  font-size: 14px;\n}\n\n.font-weight-medium {\n  font-weight: 500;\n}\n\n/* Remove spinner from number inputs in accordion */\n.no-spinner::-webkit-outer-spin-button,\n.no-spinner::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.no-spinner {\n  -moz-appearance: textfield;\n  appearance: textfield;\n}\n\n/* Disabled quantity button styles */\n.btn-outline-dark:disabled,\n.btn-outline-dark.disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n/* Mobile Cart View Accordion Styles */\n@media (max-width: 768px) {\n  /* Make accordion header more mobile-friendly */\n  .border-top .p-3 {\n    padding: 0.75rem !important;\n    background-color: #f8f9fa;\n    border-radius: 6px;\n    margin-bottom: 0.5rem;\n  }\n\n  /* Mobile accordion content styling */\n  .border-top .px-3 {\n    padding-left: 0.75rem !important;\n    padding-right: 0.75rem !important;\n  }\n\n  /* Mobile form controls in accordion */\n  .border-top .form-control-sm {\n    font-size: 14px;\n    padding: 0.5rem;\n  }\n\n  /* Mobile autocomplete dropdown */\n  .border-top .position-absolute.bg-white {\n    max-height: 150px !important;\n    font-size: 13px;\n  }\n\n  /* Mobile accordion animation */\n  .border-top .collapse {\n    transition: height 0.3s ease;\n  }\n}\n\n\n\n/* Dropdown Menu */\n.dropdown-menu-custom {\n  background: #ffffff;\n  border-top: 1px solid #e5e7eb;\n  border-bottom: 1px solid #e5e7eb;\n  animation: slideDown 0.2s ease-out;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  z-index: 50;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-6px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Order Summary Header - Clean Design */\n.order-summary-header-wrapper {\n  position: relative;\n}\n\n.header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem;\n  border-bottom: 1px solid #e9ecef;\n\n}\n\n.header-left {\n  flex: 1;\n}\n\n.header-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #2c3e50;\n}\n\n.header-title span {\n  font-size: 12px;\n  font-weight: 500;\n  color: #272829;\n}\n\n.header-info {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n/* Table/Order Badge - Less Rounded, More Rectangular */\n.info-badge {\n  background: #303e67;\n  color: white;\n  padding: 2px 4px;\n  border-radius: 4px; /* Changed from 12px to 4px for rectangular look */\n  font-size: 10px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.info-number {\n  background: #f8f9fa;\n  color: #495057;\n  padding: 4px 10px;\n  border-radius: 4px; /* More rectangular */\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.person-info {\n  font-size: 12px;\n  color: #6c757d;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: #f1f1f1;\n  padding: 4px 10px;\n  border-radius: 4px;\n}\n\n.person-info span {\n  max-width: 100px;\n  overflow: hidden;\n  position: relative;\n  display: inline-block;\n  margin: 0 5px 0 5px;\n  text-align: center;\n  text-decoration: none;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Hide the dropdown trigger - Only show dropdown on hover */\n.dropdown-trigger {\n  display: none; /* Remove the visible selector/trigger */\n}\n\n/* Tabs Section */\n.dropdown-tabs-custom {\n  display: flex;\n  gap: 4px;\n  padding: 8px;\n  background: #f8f9fa;\n  border-bottom: 1px solid #e9ecef;\n  flex-shrink: 0;\n}\n\n.tab-custom {\n  flex: 1;\n  padding: 8px 12px;\n  border: none;\n  background: white;\n  border-radius: 4px; /* Less rounded */\n  font-size: 12px;\n  font-weight: 600;\n  color: #6c757d;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.tab-custom:hover {\n  background: #e9ecef;\n  color: #495057;\n}\n\n.tab-custom.active {\n  background: #212529;\n  color: white;\n}\n\n.tab-custom-label {\n  white-space: nowrap;\n}\n\n/* Orders List in Dropdown */\n.orders-list-dropdown {\n  flex: 1;\n  overflow-y: auto;\n  padding: 8px;\n  max-height: calc(65vh - 60px);\n}\n\n.order-card-dropdown {\n  padding: 12px;\n  margin-bottom: 8px;\n  border-radius: 6px; /* Less rounded - more rectangular */\n  cursor: pointer;\n  transition: all 0.2s ease;\n  /* border: 2px solid transparent; */\n  position: relative;\n}\n\n.order-card-dropdown.active {\n  box-shadow: 0 2px 12px rgba(102, 126, 234, 0.3);\n}\n\n.order-card-dropdown:last-child {\n  margin-bottom: 0;\n}\n\n.order-card-header {\n  font-size: 13px;\n}\n\n.order-card-dropdown .fw-bold {\n  font-size: 14px;\n  color: #2c3e50;\n}\n\n.order-card-dropdown.active{\n  border: 2px solid #212529;\n}\n\n.order-card-dropdown .badge-sm {\n  font-size: 10px;\n  padding: 3px 8px;\n  border-radius: 3px; /* Less rounded for badges */\n}\n\n/* Delete Button Styling in Order Cards */\n.order-delete-btn {\n  background: transparent;\n  border: none;\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  z-index: 10;\n  position: relative;\n}\n\n.order-delete-btn:hover {\n  transform: scale(1.2);\n}\n\n.order-delete-btn:active {\n  transform: scale(0.95);\n}\n\n.order-delete-btn .mdi-close-circle {\n  font-size: 20px;\n}\n\n/* Scrollbar styling for dropdown */\n.dropdown-menu-custom::-webkit-scrollbar,\n.orders-list-dropdown::-webkit-scrollbar {\n  width: 6px;\n}\n\n.dropdown-menu-custom::-webkit-scrollbar-track,\n.orders-list-dropdown::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 10px;\n}\n\n.dropdown-menu-custom::-webkit-scrollbar-thumb,\n.orders-list-dropdown::-webkit-scrollbar-thumb {\n  background: #cbd5e0;\n  border-radius: 10px;\n}\n\n.dropdown-menu-custom::-webkit-scrollbar-thumb:hover,\n.orders-list-dropdown::-webkit-scrollbar-thumb:hover {\n  background: #a0aec0;\n}\n\n/* Empty state */\n.orders-list-dropdown .text-muted {\n  user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
